module.exports = __webpack_public_path__ + "static/media/planner.9525bbef.png";